import Button from "@/Components/Common/Buttons/Buttons";
import React from "react";
import { LuCheck } from "react-icons/lu";

const ApproveMeeting = ({ onClose, cancelSelectedAppointment,isLoading }) => {
  return (
    <>
      <div className="fixed inset-0 search-popup-bg z-40 flex justify-center items-end sm:items-center">
        <div className="w-full h-full sm:h-auto sm:w-[415px] bg-white rounded-none sm:rounded-2xl shadow border border-neutral-200 flex flex-col justify-between sm:justify-start items-center">
          {/* Mobile Header */}
          <div className="flex sm:hidden items-center justify-between w-full px-4 py-3 border-b border-gray-100 flex-shrink-0">
            <h2 className="text-base font-semibold font-poppins text-gray-900">Approve Meeting</h2>
            <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 sm:flex-none flex flex-col justify-center items-center gap-4 sm:gap-6 w-full p-6 sm:p-8 sm:pb-0">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-emerald-500 rounded-full flex justify-center items-center">
              <LuCheck className="text-white w-7 h-7 sm:w-8 sm:h-8" strokeWidth={3} />
            </div>
            <div className="flex-col justify-start items-center gap-4 sm:gap-6 flex w-full">
              <div className="flex-col justify-start items-center gap-2 flex px-2">
                <div className="text-center text-black text-2xl sm:text-[32px] font-semibold font-poppins">
                  Are you sure?
                </div>
                <div className="text-center text-neutral-400 text-sm sm:text-base font-normal font-poppins">
                  Once you approve this meeting, you can re-schedule
                  or attend this.
                </div>
              </div>
            </div>
          </div>

          {/* Buttons - Mobile */}
          <div className="w-full sm:hidden px-4 py-3 border-t border-gray-200 flex gap-2 flex-shrink-0 mt-auto bg-white">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 border-2 border-gray-300 text-gray-700 text-sm font-semibold font-poppins rounded-lg py-2.5 hover:bg-gray-50 transition-colors"
            >
              No
            </button>
            <button
              type="button"
              onClick={() => cancelSelectedAppointment()}
              className="flex-1 text-white rounded-lg text-sm font-semibold font-poppins py-2.5 transition-all bg-[#2e45df] hover:bg-[#2539c0]"
            >
              {isLoading ? 'Loading...' : 'Yes'}
            </button>
          </div>

          {/* Buttons - Desktop */}
          <div className="hidden sm:block w-full px-8 pb-8 pt-6">
            <div className="border-t border-zinc-100 pt-6"></div>
            <div className="w-full flex gap-6">
              <div className="flex-1 font-poppins">
                <Button
                  border={"1px solid #D53033"}
                  textColor={"#D53033"}
                  width={"100%"}
                  borderRadius={"10px"}
                  onClick={onClose}
                  padding={"12px 16px"}
                >
                  No
                </Button>
              </div>
              <div className="flex-1 font-poppins">
                <Button
                  backgroundColor={"#354EF0"}
                  border={"1px solid #354EF0"}
                  textColor={"white"}
                  width={"100%"}
                  onClick={() => cancelSelectedAppointment()}
                  borderRadius={"10px"}
                  padding={"12px 16px"}
                >
                  {isLoading ? 'Loading...' : 'Yes'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApproveMeeting;
